module.exports = __webpack_public_path__ + "img/2-7.e11f174b.png";